export default "__VITE_ASSET__CtoUdNMc__"